<script setup>
const contactUsUrl = import.meta.env.VITE_SE_FOOTER_CONTACT_US_URL || '#';
const telephoneNumber = import.meta.env.VITE_SE_FOOTER_PHONE_NUMBER || '';
const emailAddress = import.meta.env.VITE_SE_FOOTER_EMAIL_ADDRESS || '';
const privacyNoticeUrl = import.meta.env.VITE_SE_FOOTER_PRIVACY_NOTICE_URL || '#';
const accessibilityStatementUrl = import.meta.env.VITE_SE_FOOTER_ACCESSIBILITY_STATEMENT_URL || '#';
const cookiePolicyUrl = import.meta.env.VITE_SE_FOOTER_COOKIE_POLICY_URL || '#';
const netreadyLtdUrl = import.meta.env.VITE_SE_FOOTER_NETREADY_LTD_URL || '#';
</script>

<template>
    <v-row class="pa-0">
        <v-col cols="12" md="2">
            <v-row>
                <v-col cols="12" class="pb-0">
                    <p class="font-size-16 text-white pl-7" tabindex="0">Follow Us:</p>
                </v-col>
                <v-col cols="2"  md="3" lg="3" xl="3">
                    <a class="se-hyperlink" href="https://www.facebook.com/profile.php?id=61561896838470" target="_blank">
                        <v-icon color="white" size="22" class="mr-2 footer-icon" aria-hidden="false" aria-label="facebook">fa-brands fa-facebook</v-icon>
                    </a>
                </v-col>
                <v-col cols="2" md="3" lg="3" xl="3">
                    <a class="se-hyperlink" href="https://www.instagram.com/la_fostering_se?igsh=MWo2b2JyNDlmNzJlYQ%3D%3D" target="_blank">
                        <v-icon color="white" size="22" class="mr-2 footer-icon" aria-hidden="false" aria-label="instagram">fa-brands fa-instagram</v-icon>
                    </a>
                </v-col>
                <v-col cols="2" md="3" lg="3" xl="3">
                    <a class="se-hyperlink" href="https://x.com/i/flow/login?redirect_after_login=%2FLA_Fostering_SE" target="_blank">
                        <v-icon color="white" size="22" class="mr-2 footer-icon" aria-hidden="false" aria-label="x">fa-brands fa-x-twitter</v-icon>
                    </a>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" md="3">
            <v-row>
                <v-col cols="12" class="d-flex align-center">
                    <a class="se-hyperlink" :href="contactUsUrl">
                        Contact us
                    </a>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                    <v-icon size="16" class="mr-2">fa fa-phone</v-icon>
                    <a class="se-hyperlink" :href="'tel:' + telephoneNumber" target="_blank">
                        {{ telephoneNumber }}
                    </a>
                </v-col>
                <v-col cols="12" class="d-flex">
                    <v-icon size="16" class="mt-1 mr-2">fa fa-envelope</v-icon>
                    <a class="se-hyperlink" :href="'mailto:' + emailAddress" target="_blank">
                        {{ emailAddress }}
                    </a>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" md="3">
            <v-row class="text-center text-start-mobile">
                <v-col cols="12">
                    <a class="se-hyperlink" :href="privacyNoticeUrl">
                        Privacy Notice
                    </a>
                </v-col>
                <v-col cols="12">
                    <a class="se-hyperlink" :href="accessibilityStatementUrl">
                        Accessibility Statement
                    </a>
                </v-col>
                <v-col cols="12">
                    <a class="se-hyperlink" :href="cookiePolicyUrl">
                        Cookie Policy
                    </a>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" md="4">
            <v-row class="justify-end text-end">
                <v-col cols="12">
                    <div class="d-flex justify-end justify-start-mobile align-middle" tabindex="0">
                        <v-icon size="16" class="mr-2 mt-1" aria-hidden="false" aria-label="copyright">far fa-copyright</v-icon>
                        <p class="text-white text-no-wrap text-right">Fostering South East - {{ new Date().getFullYear() }}</p>
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="d-flex justify-end justify-start-mobile align-middle">
                        <v-icon size="16" class="mt-1 mr-2">far fa-globe</v-icon>
                        <a class="se-hyperlink text-no-wrap" :href="netreadyLtdUrl" target="_blank">
                            Netready Ltd. <v-icon size="12">far fa-arrow-up-right-from-square</v-icon>
                        </a>
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>


<style scoped>
:deep(.far.fa-copyright),
:deep(.far.fa-globe) {
    display: flex;
}

.footer-link > .se-hyperlink a {
    color: white;
}

.se-hyperlink a:visited {
    color: rgb(var(--v-theme-seLinkHoverVisited)) !important;
}

:deep(.se-hyperlink .footer-icon) {
    text-decoration: none !important;
}

@media only screen and (max-width: 768px) {
    .text-start-mobile {
        text-align: start !important;
    }

    .justify-start-mobile {
        justify-content: start !important;
    }
}
</style>

<style>
footer {
    border-top: 10px solid #66D4F1 !important;
    background-image: url('/static/images/heart-pin-se.png') !important;
    background-position: 95% 50% !important;
    background-repeat: no-repeat !important;
}
</style>
